<template>
    <CContainer :fluid="true">
        <CRow>
            <CCol>
                <h1 class="mt-2">Components Testing</h1>
            </CCol>
        </CRow>
        <CRow>
            <CCol>
                <h2>Page Components</h2>
            </CCol>
        </CRow>
        <CRow>
            <CCol md="3" sm="12">
                <h3>CCInputExtraTime</h3>
                <CCInputExtraTime
                    :value.sync="inputExtraTimeValue"
                    :horizontal="true"
                    labelDays="Días"
                    labelMonths="Meses"
                    labelYears="Años"
                    size="sm"
                />
                <div>
                    <pre>{{ inputExtraTimeValue }}</pre>
                </div>
            </CCol>
        </CRow>

        <CRow>
            <CCol md="12" sm="12">
                <h3>CCSubQueryBuilder</h3>
                <CCSubQueryBuilder
                    :value.sync="subQueryComponentValue"
                    size="sm"
                />
                <div>
                    <pre>{{ subQueryComponentValue }}</pre>
                </div>
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>
import pageMixin from "~/mixins/page.js";
import CCInputExtraTime from "~/pages/app/integration/components/CCInputExtraTime.vue";
import CCSubQueryBuilder from "../Segments/Components/CCSubQueryBuilder.vue";

export default {
    name: "TestComponentsPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin],
    components: {
        CCInputExtraTime,
        CCSubQueryBuilder
    },
    data() {
        return {
            inputExtraTimeValue: {
                days: 1,
                months: null,
                years: 0,
            },
            subQueryComponentValue: {},
        };
    },
    methods: {},
    mounted() {
        this.updatePageLoading(false);
    },
};
</script>
